import { DA_DATA_FIRST_NAME, DA_DATA_LAST_NAME, DA_DATA_PATRONYMIC } from '../config';
import type { TDaDataNamePart } from '../models';
import type { ISuggestion } from '../dadata-service/models';

import type { INamePartCache, ISetCache } from './models';

export class FioCache {
    cache: INamePartCache = {
        [DA_DATA_LAST_NAME]: {},
        [DA_DATA_FIRST_NAME]: {},
        [DA_DATA_PATRONYMIC]: {},
    };

    set = async ({ data, namePart, value }: ISetCache) => {
        this.cache[namePart][value] =
            // get suggestions
            await data;
    };

    get = (namePart: TDaDataNamePart, value: string): ISuggestion[] => {
        return this.cache[namePart][value];
    };
}
